/**
 * Created by sunshine on 2016/12/27.
 */
/*eslint-disable*/
let apiLinks;
let ssodailyurl = window.configObject.WB_HOST;
const QueryString = (item)=>{
    var svalue = window.location.search.match(new RegExp("[\?\&]" + item + "=([^\&]*)(\&?)","i"));
    return svalue ? svalue[1] : svalue;
}
// dev发环境 http://yc.yonyou.com 360 账号为ycwyg56
// B环境 wuyanguo 1219
// 正式环境 https://yc.yonyoucloud.com
// ================= 需要修改的部分 =================//
let yc = window.location.protocol + "//" + window.location.host;
// let enterpriseId;
// let tenantid;
let enterpriseId='1';
let tenantid='c3wnyov7';
// 专属化测试暂时方案 之后专属化需要定制开发
// if( QueryString('tenantid') && QueryString('enterpriseId')) {
//   enterpriseId = QueryString('enterpriseId');
//   tenantid = QueryString('tenantid');
//   window.localStorage.setItem('enterpriseId',enterpriseId)
//   window.localStorage.setItem('tenantid',tenantid)
// }else {
//   enterpriseId = window.localStorage.getItem('enterpriseId');
//   tenantid =window.localStorage.getItem('tenantid');
// }
// console.log(`tenantid: ${tenantid}`)
// console.log(`enterpriseId: ${enterpriseId}`)
// 用ys_cgs测试用
// tenantid = 'h050u1t9'
// slogan
let slogan = "郎酒股份供应商门户";
let logourl = "static/imgs/logo.png";
// 公司名字
let companyname = "郎酒集团";
let companyfullname = "郎酒集团";
// 公司官网
let companyHomePage = 'https://srm.langjiu.cn/';
// 联系我们页面
let companyContactUs = "";
// 分支名字或访问context
let portaltype = "home";

let bannerList = [
  {
    class: "carousel-bg-jsqp3",
  },
];
// 联系电话
let telephone = "13880692694 倪经理";
let address = "四川省成都市双流区华阳镇EOD总部办公一期";
let servicetime = "周一至周五 上午08:30至下午17:30";
let caslogout =
  "/logout?service=" + encodeURIComponent('/yonbip-cpu-bcsourcing/ucf-wh/home/home.html');
// https%3a%2f%2fu8cpur-daily.yyuap.com%2fdailytest%2f
caslogout = window.configObject.WB_HOST + "/" + caslogout
// ================= 需要修改的部分 =================//
apiLinks = {
  tenantId: tenantid,
  enterpriseId: enterpriseId,
  ssodailyurl: ssodailyurl,
  logourl: logourl,
  address: address,
  companyfullname: companyfullname,
  telephone: telephone,
  servicetime: servicetime,
  companyname: companyname,
  context: portaltype,
  bannerList: bannerList,
  slogan: slogan,
  companyContactUs: companyContactUs,
  selfHome: companyHomePage,
  // welcome: "您好!欢迎来到" + companyname + "采购门户!",
  welcome: "您好!欢迎来到郎酒股份供应商门户",
  portaltype: portaltype,
  // materiaClass: yc + '/yonbip-cpu-portal/yuncai/jsonp/pubmaterialClass?enterpriseId=' + enterpriseId,
  materiaClass:
    yc + '/yonbip-cpu-portal/yuncai/jsonp/getMaterialClass?enterpriseId=' +
    enterpriseId +
    "&parentId=",
  orgClass:
    yc + '/yonbip-cpu-portal/yuncai/org/getorgbydef?pageIndex=0&pageSize=100&org_type=2&org_types=0&enterprise_id=' +
    enterpriseId,
  southCement: {
    home: companyHomePage,
  },
  caslogout: caslogout,
  // 注册页面
  register:
    yc +
    "/yonbip-cpu-portal/ucf-wh/cpu-portal/portalcas.html#/pages/supplymgr/supplyapplyregister?purentid=" +
    enterpriseId +
    "&agree=1&ipuid=" +
    portaltype,
  // 进入工作台/注册
  enterWorkbench: window.configObject.WB_HOST + "/login",
  // 供应商申请
  suppliersFor:
    yc +
    "/yonbip-cpu-portal/ucf-wh/cpu-portal/portalcas.html#/pages/supplymgr/addSupplyApply?purentid=" +
    enterpriseId +
    "&ipuid=" +
    portaltype +
    "&v=" +
    Date.parse(new Date().toLocaleDateString()),
  // 首页左侧数据相关链接
  infoTable: {
    latest: [
      yc + '/yonbip-cpu-portal/yuncai/jsonp/supplierOffer/list?type=pp&bidType=allNotice&supEnterpriseIds=' +
        enterpriseId +
        "&status=4&pageIndex=0&pageSize=6",
      "latest2",
      "latest3",
    ],
    area: [
      yc + '/yonbip-cpu-portal/yuncai/jsonp/supplierOffer/list?type=pp&bidType=allNotice&supEnterpriseIds=' +
        enterpriseId +
        "&status=4&pageIndex=0&pageSize=6",
      "area2",
      "area3",
      "area4",
      "area5",
      "area6",
      "area7",
      "area8",
    ],
    type: [
      yc + '/yonbip-cpu-portal/yuncai/jsonp/supplierOffer/list?type=pp&bidType=allNotice&supEnterpriseIds=' +
        enterpriseId +
        "&status=4&pageIndex=0&pageSize=6",
      "2",
      "3",
      "4",
    ],
  },
  // 物资招标公告链接(之后封装成一个对象目前只有两个)
  purchasetableDate: [
    // 询价公告
    yc + '/yonbip-cpu-portal/yuncai/jsonp/supplierOffer/list?type=pp&bidType=purchase&supEnterpriseIds=' +
      enterpriseId +
      "&status=0&pageSize=10&pageIndex=0",
    // 招标公告
    yc + '/yonbip-cpu-portal/yuncai/jsonp/supplierOffer/list?type=pp&bidType=purchase&supEnterpriseIds=' +
      enterpriseId +
      "&status=4&pageSize=10&pageIndex=0",
    // 中标公告
    yc + '/yonbip-cpu-portal/yuncai/jsonp/supplierOffer/list?type=pp&bidType=purchase&supEnterpriseIds=' +
      enterpriseId +
      "&status=10&pageSize=10&pageIndex=0",
    // 竞价公告
    "",
    // 竞价性谈判
    "",
  ],
  // 物流招标公告链接
  logisticstableDate: [
    // 询价公告
    "",
    // 招标公告
    yc + '/yonbip-cpu-portal/yuncai/jsonp/supplierOffer/list?type=pp&bidType=logistics&supEnterpriseIds=' +
      enterpriseId +
      "&status=6&pageSize=10&pageIndex=0",
    // 中标公告
    yc + '/yonbip-cpu-portal/yuncai/jsonp/supplierOffer/list?type=pp&bidType=logistics&supEnterpriseIds=' +
      enterpriseId +
      "&status=7&pageSize=10&pageIndex=0",
    // 竞价公告
    "",
    // 竞价性谈判
    "",
  ],
  // 工程招标公告链接
  logisticsestableDate: [
    // 询价公告
    "",
    // 招标公告
    yc + '/yonbip-cpu-portal/yuncai/jsonp/supplierOffer/list?type=pp&bidType=logistics&supEnterpriseIds=' +
      enterpriseId +
      "&status=11&pageSize=10&pageIndex=0",
    // 中标公告
    yc + '/yonbip-cpu-portal/yuncai/jsonp/supplierOffer/list?type=pp&bidType=logistics&supEnterpriseIds=' +
      enterpriseId +
      "&status=13&pageSize=10&pageIndex=0",
  ],
  // 服务招标公告链接
  engineeringtableDate: [
    // 询价公告
    "",
    // 招标公告
    yc + '/yonbip-cpu-portal/yuncai/jsonp/supplierOffer/list?type=pp&bidType=logistics&supEnterpriseIds=' +
      enterpriseId +
      "&status=12&pageSize=10&pageIndex=0",
    // 中标公告
    yc + '/yonbip-cpu-portal/yuncai/jsonp/supplierOffer/list?type=pp&bidType=logistics&supEnterpriseIds=' +
      enterpriseId +
      "&status=14&pageSize=10&pageIndex=0",
  ],
  // 查看详情不同status跳转页面 bidDetails: cpu-fe-bid -> cpu-fe-tender
  details: {
    bidDoc: yc + '/yonbip-cpu-bid/ucf-wh/cpu-bid/dist/bidddocread/index.html?type=1&id=',
    bidDetails:
      yc + '/yonbip-cpu-bid/ucf-wh/cpu-tender/dist/supplyenlistshowother/index.html?show=1&id=',
    bidNotice:
      yc +
      "/yonbip-cpu-portal/ucf-wh/cpu-portal/portalcas.html#/pages/pricedecision/pricedecisionnotice_publish?id=",
    bidMsg: yc + '/yonbip-cpu-bid/ucf-wh/cpu-bid/dist/submitbidnotice/index.html?type=3&id=',
    bidMsg2:
      yc +
      "/yonbip-cpu-portal/ucf-wh/cpu-portal/portalcas.html#/pages/pricedecision/pricedecisionnotice_publish?id=",
    // 竞价中标通知
    bidMsg3:
      yc + '/yonbip-cpu-bid/ucf-wh/cpu-bidauction/bidNotificationPublic/index.zh_CN.html?id=',
    // 竞价公告
    bidauctionNotice:
      yc + '/yonbip-cpu-bid/ucf-wh/cpu-bidauction/bidding_Apply/index.zh_CN.html?id=',
    inquiryDetails: yc + '/yonbip-cpu-bid/ucf-wh/cpu-tender/dist/inquirydetail/index.html?id=',
    company:
      yc +
      "/yonbip-cpu-portal/ucf-wh/cpu-portal/portalcas.html#/pages/notice/noticeSystemView?roleType=3&id=",
    noticeMore:
      yc + '/yonbip-cpu-portal/ucf-wh/cpu-dashboard/index.html#/anoucementlist?tenantid=' + tenantid,
    lbnoticeMore:
      yc + '/yonbip-cpu-portal/ucf-wh/cpu-dashboard/index.html#/noticelist?supEnterpriseId=' +
      enterpriseId +
      "&status=18",
    cqnoticeMore:
      yc + '/yonbip-cpu-portal/ucf-wh/cpu-dashboard/index.html#/noticelist?supEnterpriseId=' +
      enterpriseId +
      "&status=19",
    lbNotice: yc + '/yonbip-cpu-bid/ucf-wh/cpu-bid/dist/lbnotice/index.html?id=', //流标公告
    cqNotice: yc + '/yonbip-cpu-bid/ucf-wh/cpu-bid/dist/clarifynotice/index.html?id=', //澄清公告
    
    lawnotice: yc + '/yonbip-cpu-lawbid/ucf-wh/cpu-lawbid/portalcas.html#/pages/bid_section/biddingDetail',
    biddocDetails: yc + '/yonbip-cpu-bid/ucf-wh/cpu-tender/dist/supplyenlistshowbiddoc/index.html?show=1&id=',
    supplyNotice: yc + '/yonbip-cpu-lawbid/ucf-wh/cpu-lawbid/portalcas.html#/pages/supply_notice/index?id=',
    lblawNotice: yc + '/yonbip-cpu-lawbid/ucf-wh/cpu-lawbid/portalcas.html#/pages/bid_exception_handling/noticeDetail?id=',// lawbid流标公告
    lawBgNotice: yc + '/yonbip-cpu-lawbid/ucf-wh/cpu-lawbid/portalcas.html#/pages/bid_notice/webportalviewnotice?id=',//lawbid变更公告
    feCqNotice: yc + '/yonbip-cpu-bid/ucf-wh/cpu-bid/dist/clarifynotice/index.html?id=',//澄清公告
    lawCqNotice: yc + '/yonbip-cpu-lawbid/ucf-wh/cpu-lawbid/portalpro.html#/pages/bid_problemresponse/index?type=0&id='//lawbid澄清公告
  },
  notice: {
    company: "/yonbip-cpu-yop/systemnotice/portalPrivateNotice",
    bidding:
      yc + '/yonbip-cpu-portal/yuncai/jsonp/supplierOffer/list?type=pp&bidType=allBidNotice&supEnterpriseIds=' +
      enterpriseId +
      "&status=5&pageSize=6&pageIndex=0",
    clarify: "",
    lbnotice:
      yc + '/yonbip-cpu-portal/yuncai/jsonp/supplierOffer/list?type=pp&bidType=purchase&supEnterpriseIds=' +
      enterpriseId +
      "&status=18&pageIndex=0&pageSize=6",
    cqnotice:
      yc + '/yonbip-cpu-portal/yuncai/jsonp/supplierOffer/list?type=pp&bidType=purchase&supEnterpriseIds=' +
      enterpriseId +
      "&status=19&pageIndex=0&pageSize=6",
  },
  // 联系我们页面
  contact:
    yc + '/yonbip-cpu-bid/ycctrl/projectdef/getBidCountInfo?enterpriseId=' +
    enterpriseId,
  // 是否已申请过供应商
  agreement:
    yc + '/yonbip-cpu-suppliermgr/supplyApply/isExistApply?purEntId=' + enterpriseId,
};
export { apiLinks };



// WEBPACK FOOTER //
// ./src/api/links.js